/** Hook: fetch the entire public portfolio from /api/public/portfolio. */
import { useEffect, useState, useCallback } from "react";
import { publicApi } from "../lib/api";

export function usePortfolio() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const d = await publicApi.portfolio();
      setData(d);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refetch(); }, [refetch]);

  return { data, loading, error, refetch };
}
